const telRegExp = /^\(\d{2}\) \d{4,5}-\d{4}$/;

function hasObviousPhonePattern(phone) {
  const digits = phone.replace(/[^\d]/g, '')
  const numberPart = digits.slice(2)
  if (!numberPart) return true
  if (/^(\d)\1+$/.test(numberPart)) return true
  if ('0123456789'.includes(numberPart)) return true
  if ('9876543210'.includes(numberPart)) return true
  return false
}

export const validTel = (data) => {
  if (!telRegExp.test(data)) return false
  if (hasObviousPhonePattern(data)) return false
  return true
}
